/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Plugins_Contact_Support_TextInputs */

const en_team_manager_plugins_contact_support_text = /** @type {(inputs: Team_Manager_Plugins_Contact_Support_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teams can purchase additional licenses by contacting `)
};

const fr_team_manager_plugins_contact_support_text = /** @type {(inputs: Team_Manager_Plugins_Contact_Support_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les équipes peuvent acheter des licences supplémentaires en contactant `)
};

const de_team_manager_plugins_contact_support_text = /** @type {(inputs: Team_Manager_Plugins_Contact_Support_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teams können zusätzliche Lizenzen erwerben, indem sie sich an [Kontaktinformationen einfügen] wenden.`)
};

const it_team_manager_plugins_contact_support_text = /** @type {(inputs: Team_Manager_Plugins_Contact_Support_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I team possono acquistare licenze aggiuntive contattando`)
};

const ru_team_manager_plugins_contact_support_text = /** @type {(inputs: Team_Manager_Plugins_Contact_Support_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Команды могут приобрести дополнительные лицензии, связавшись с нами.`)
};

const es_team_manager_plugins_contact_support_text = /** @type {(inputs: Team_Manager_Plugins_Contact_Support_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los equipos pueden comprar licencias adicionales contactándose`)
};

const zh_cn2_team_manager_plugins_contact_support_text = /** @type {(inputs: Team_Manager_Plugins_Contact_Support_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`团队可以通过联系以下机构购买额外的许可证：`)
};

const ja_team_manager_plugins_contact_support_text = /** @type {(inputs: Team_Manager_Plugins_Contact_Support_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チームは連絡することで追加のライセンスを購入することができます`)
};

const hi_team_manager_plugins_contact_support_text = /** @type {(inputs: Team_Manager_Plugins_Contact_Support_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टीमें संपर्क करके अतिरिक्त लाइसेंस खरीद सकती हैं।`)
};

const pt_pt2_team_manager_plugins_contact_support_text = /** @type {(inputs: Team_Manager_Plugins_Contact_Support_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As equipes podem adquirir licenças adicionais entrando em contato com`)
};

/**
* | output |
* | --- |
* | "Teams can purchase additional licenses by contacting" |
*
* @param {Team_Manager_Plugins_Contact_Support_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_plugins_contact_support_text = /** @type {((inputs?: Team_Manager_Plugins_Contact_Support_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Plugins_Contact_Support_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_plugins_contact_support_text(inputs)
	if (locale === "de") return de_team_manager_plugins_contact_support_text(inputs)
	if (locale === "it") return it_team_manager_plugins_contact_support_text(inputs)
	if (locale === "ru") return ru_team_manager_plugins_contact_support_text(inputs)
	if (locale === "es") return es_team_manager_plugins_contact_support_text(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_plugins_contact_support_text(inputs)
	if (locale === "ja") return ja_team_manager_plugins_contact_support_text(inputs)
	if (locale === "hi") return hi_team_manager_plugins_contact_support_text(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_plugins_contact_support_text(inputs)
	return en_team_manager_plugins_contact_support_text(inputs)
});